import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const REVIEWS = [{
  name: 'Budi Santoso',
  role: 'Perjalanan Dinas',
  text: 'Pelayanan sangat profesional, mobil bersih dan wangi. Driver ramah dan tepat waktu. Sangat recommended untuk kebutuhan dinas!'
}, {
  name: 'Siti Rahmawati',
  role: 'Wisata Religi',
  text: 'Perjalanan ziarah keluarga jadi nyaman banget. Innova-nya prima, sopirnya sabar dan hafal rute. Terima kasih WP Transport!'
}, {
  name: 'Andi Pratama',
  role: 'City Tour Garut',
  text: 'Booking cepat lewat WhatsApp, harga kompetitif, unit sesuai foto. Liburan keluarga di Garut jadi lebih berkesan.'
}];
export function Testimonials() {
  return <section id="testimoni" className="relative bg-ink py-24" data-id="element-180" data-mp="v9or9rdnlu65">
      <div className="mx-auto max-w-7xl px-5" data-id="element-181" data-mp="qac3n4eykj2i">
        <SectionHeading eyebrow="Testimoni" title={<>Kata <span className="text-gold-gradient" data-id="element-183" data-mp="h681ea14tyd0">Pelanggan Kami</span></>} subtitle="Kepercayaan pelanggan adalah prioritas utama kami." data-id="element-182" data-mp="qbeqn195u1d5" />

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-184" data-mp="m6cio29v6x4a">
          {REVIEWS.map((r, i) => <motion.div key={r.name} initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.12
        }} className="relative flex flex-col rounded-3xl border border-white/5 bg-ink-card p-7 transition-colors hover:border-gold/40" data-id="element-185" data-mp="79v7pc5l7ki9" data-mpi={i}>
              <QuoteIcon className="absolute right-6 top-6 h-10 w-10 text-gold/10" data-id="element-186" data-mp="v5ptay9q5rql" />
              <div className="mb-4 flex gap-1" data-id="element-187" data-mp="v3mvhs2byubb">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-gold text-gold" data-id="element-188" data-mp="1ith6s5704atg" data-mpi={s} />)}
              </div>
              <p className="flex-1 text-sm leading-relaxed text-white/70" data-id="element-189" data-mp="1xhqvdh4steqb">“{r.text}”</p>
              <div className="mt-6 flex items-center gap-3" data-id="element-190" data-mp="1siweikqe608u">
                <div className="grid h-11 w-11 place-items-center rounded-full gold-border font-display font-semibold text-gold" data-id="element-191" data-mp="1sjfmb8mbv895">
                  {r.name.charAt(0)}
                </div>
                <div data-id="element-192" data-mp="1jhg4wf7ei25o">
                  <div className="text-sm font-semibold text-white" data-id="element-193" data-mp="1jkc384n5usun">{r.name}</div>
                  <div className="text-xs text-gold/80" data-id="element-194" data-mp="1ekpo1pnrv2j7">{r.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}